import '../styles/index.sass'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { createBrowserHistory as createHistory } from 'history'
import configureStore from './configureStore'
import { AppContainer } from 'react-hot-loader'
import 'moment/locale/fi'

const history = createHistory()
const store = configureStore(history)

const el = document.getElementById('app')

let render = () => {
  let Routes = require('./routes').default
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>{Routes}</ConnectedRouter>
    </Provider>,
    el
  )
}

if (module.hot) module.hot.accept('./routes', () => render())

render()
